module.exports = __webpack_public_path__ + "img/minus.d9a72a1b.svg";